import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Text",
    type: "object",
    properties: {
      ...Utils.properties,
      default: {
        label: "Default value",
        type: "string",
        minLength: 0,
        default: "",
      },
      // Three, where pagews' registry has seven. `html`, `css`, `javascript`
      // and `json` are code formats, and types-values would resolve the first
      // three to CodeMirror widgets this app deliberately does not register —
      // a person filling in a capture form has no use for an HTML editor. See
      // app/code/src/widgets/register.js.
      type: {
        label: "Type",
        type: "string",
        default: "text",
        enum: ["text", "textarea", "password"],
      },
      pattern: {
        label: "Pattern",
        type: "string",
        minLength: 0,
        default: "",
      },
      minLength: {
        label: "Minimum length",
        type: "number",
        default: 0,
      },
      maxLength: {
        label: "Maximum length",
        type: "number",
        default: 128,
      },
    },
    required: [],
  },
];
